import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api } from "../lib/api";

const FALLBACK = ["100% NATUREL", "NUTRITION ESSENTIELLE", "ÉNERGIE VIBRANTE", "BIEN-ÊTRE", "ÉDITION LIMITÉE"];

export default function EditorialMarquee() {
  const [items, setItems] = useState(FALLBACK);
  useEffect(() => {
    api.get("/site/marquee").then(r => {
      if (Array.isArray(r.data?.items) && r.data.items.length > 0) setItems(r.data.items);
    }).catch(() => {});
  }, []);
  return (
    <div className="bg-[#1A2E1A] text-white py-4 border-y border-[#7AC143]/20" data-testid="editorial-marquee">
      <Marquee speed={40} gradient={false}>
        {items.concat(items).map((it, i) => (
          <span key={i} className="mx-12 text-xs tracking-[0.3em] font-bold uppercase">
            <span className="text-[#7AC143] mr-12">✦</span>{it}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
